import { useAppContext } from '@/contexts/AppContext';
import useAuth from '@/hooks/useAuth';
import i18n from '@/languages/i18n';
import React from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import Helmet from 'react-helmet';
import { AppUrls } from '@/urls';
import UnAuthorizedLayout from './UnAuthorizedLayout';
import ScrollToTop from '@/components/App/ScrollToTop';
import DefaultLayout from './DefaultLayout';
import AgentLayout from './AgentLayout';
import PasswordExpiredPage from '@/pages/Auth/PasswordExpired.page';
import BookingDetailPage from '@/pages/BookingDetail/BookingDetail.page';
import PageLoading from '@/components/App/PageLoading';
import SsoLoginPage from '@/pages/Auth/SSOLogin.page';
import TermsAndConditionsPage from '@/pages/StaticPages/TermsAndConditions.page';
import LogoutPage from '@/pages/Auth/LogoutPage';

export default function AppLayout() {
  const { auth, authLoaded } = useAppContext();
  const { pathname } = useLocation();
  useAuth();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  if (!authLoaded) {
    return <PageLoading />;
  }

  return (
    <>
      <Helmet htmlAttributes={{ lang: i18n.language }} />
      {auth ? (
        <Switch>
          <Route path={AppUrls.Logout} component={LogoutPage} exact />
          <Route path={AppUrls.SSOLogin} component={SsoLoginPage} exact />
          <Route path={AppUrls.PasswordExpired} component={PasswordExpiredPage} exact />
          <Route path={AppUrls.BookingDetail} component={BookingDetailPage} exact />
          <Route path={AppUrls.TermsAndConditions} component={TermsAndConditionsPage} exact />
          <Route path={AppUrls.__agent} component={AgentLayout} />
          <Route path={AppUrls.HomePage} component={DefaultLayout} />

          <Redirect from="*" to={AppUrls.HomePage} />
        </Switch>
      ) : (
        <Switch>
          <Route path={AppUrls.Logout} component={LogoutPage} exact />
          <Route path={AppUrls.SSOLogin} component={SsoLoginPage} exact />
          <Route path={AppUrls.__unauthorized} component={UnAuthorizedLayout} />
          <Route path={AppUrls.TermsAndConditions} component={TermsAndConditionsPage} exact />
          <Redirect from="*" to={AppUrls.Login} />
        </Switch>
      )}
      <ScrollToTop />
    </>
  );
}
